import { DEFAULT_BASEMAP_ID } from './map-shared.js';

/** Use the resolved editor appearance only when starting a new map. */
export function getInitialBasemapId() {
  return document.documentElement.dataset.theme === 'dark' ? 'dark' : DEFAULT_BASEMAP_ID;
}
